module.exports = __webpack_public_path__ + "img/earthPic.f5295016.jpg";